var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0"},[_c('div',{},[_c('FunilChart',{attrs:{"filter":_vm.filter}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }